import React from 'react';
import { Slide, Stack } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { Dialog, SubTitle, Title } from './OfflineComponent.styles';

// eslint-disable-next-line prefer-arrow-callback
const Transition = React.forwardRef(function TransitionInner(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OfflineComponent = ({ open }: { open: boolean }) => (
  <Dialog open={open} slots={{ transition: Transition }}>
    <Stack sx={{ gap: '8px', alignItems: 'center' }}>
      <Title>{`📡 You're Offline`}</Title>
      <SubTitle>Please check your internet connection to continue.</SubTitle>
    </Stack>
  </Dialog>
);

export default OfflineComponent;
